import { startTrappingFocus, stopTrappingFocus } from "../../utilities/trap-focus.js";
const closeModal = (modal, props = {}) => {
  const { onCloseFinish, onCloseStart } = props;
  modal.removeAttribute("open");
  modal.removeAttribute("aria-hidden");
  stopTrappingFocus(modal);
  document.body.classList.remove("tds-modal--is-open");
  modal.classList.remove("tds-modal--scrolling");
  if (onCloseStart)
    onCloseStart();
  if (onCloseFinish) {
    setTimeout(onCloseFinish, 500);
  }
};
const openModal = (modal, props = {}) => {
  const { onOpen } = props;
  modal.setAttribute("open", "");
  modal.setAttribute("aria-hidden", "false");
  if (modal.nextElementSibling && modal.nextElementSibling.classList.contains("tds-modal-backdrop")) {
    document.body.classList.add("tds-modal--is-open");
  }
  startTrappingFocus(modal);
  window.addEventListener("keyup", (e) => {
    switch (e.key) {
      case "Esc":
      case "Escape":
        closeModal(modal, props);
        break;
      default:
        break;
    }
  });
  if (modal) {
    modal.scrollTop = 0;
    modal.addEventListener("scroll", () => {
      if (modal.getAttribute("open") !== void 0 && modal.scrollTop > 0) {
        modal.classList.add("tds-modal--scrolling");
      } else {
        modal.classList.remove("tds-modal--scrolling");
      }
    });
  }
  if (onOpen)
    onOpen();
};
const initModalOpener = (opener, props = {}) => {
  const { parent = document } = props;
  const id = opener.getAttribute("data-tds-open-modal") || "";
  const targetModal = parent.querySelector(`#${id}`) || document.getElementById(id);
  if (!targetModal) {
    console.warn(
      "TDS Modal does not have the proper vanilla html structure. See the docs for example usage"
    );
  } else {
    opener.addEventListener("click", () => openModal(targetModal, props));
  }
};
const initModalCloser = (closer, props = {}) => {
  const { parent = document } = props;
  const id = closer.getAttribute("data-tds-close-modal") || "";
  const targetModal = parent.querySelector(`#${id}`) || document.getElementById(id);
  if (!targetModal) {
    console.warn(
      "TDS Modal does not have the proper vanilla html structure. See the docs for example usage"
    );
  } else {
    closer.addEventListener("click", () => {
      closeModal(targetModal, props);
    });
  }
};
const initModalToggle = (toggle, props = {}) => {
  const { parent = document } = props;
  const id = toggle.getAttribute("data-tds-toggle-modal") || "";
  const targetModal = parent.querySelector(`#${id}`) || document.getElementById(id);
  if (!targetModal) {
    console.warn(
      "TDS Modal does not have the proper vanilla html structure. See the docs for example usage"
    );
  } else {
    toggle.addEventListener("click", () => {
      if (targetModal.hasAttribute("open")) {
        closeModal(targetModal, props);
      } else {
        openModal(targetModal, props);
      }
    });
  }
};
const initModals = (props = {}) => {
  const { parent = document } = props;
  const openers = Array.from(parent.querySelectorAll("[data-tds-open-modal]"));
  const closers = Array.from(parent.querySelectorAll("[data-tds-close-modal]"));
  const toggles = Array.from(parent.querySelectorAll("[data-tds-toggle-modal]"));
  openers.forEach((opener) => {
    initModalOpener(opener, props);
  });
  closers.forEach((closer) => {
    initModalCloser(closer, props);
  });
  toggles.forEach((toggle) => {
    initModalToggle(toggle, props);
  });
};
export {
  closeModal,
  initModalCloser,
  initModalOpener,
  initModalToggle,
  initModals,
  openModal
};
